import React from 'react';

import Tabs from '../../Tabs';

import useAddQueryParam from '../../../hooks/useAddQueryParams';

export default function AddOrEditPageTabs({ tabs }) {
  const { addQueryParam, currentQueryParam } = useAddQueryParam('tab');

  const extendedTabs = tabs.map((tab) => ({
    label: tab.label,
    onClick: () => {
      if (tab.onClick) {
        tab.onClick?.();
      } else {
        addQueryParam('tab', tab.label);
      }
    },
    activeOn: tab.activeOn,
    displayLabel: tab.displayLabel,
    active: tab.active,
    isHidden: tab.isHidden,
  }));

  return <Tabs tabs={extendedTabs} currentTab={currentQueryParam} />;
}
